import { render, staticRenderFns } from "./MarketSegmentFormPart.vue?vue&type=template&id=2a37e870"
import script from "./MarketSegmentFormPart.vue?vue&type=script&lang=js"
export * from "./MarketSegmentFormPart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports